var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.649 3H7.35099C6.60596 3 6 3.61 6 4.36V19.64C6 20.39 6.60596 21 7.35099 21H13.7583C13.9868 21 14.2053 20.91 14.3642 20.74L17.7517 17.34C17.9106 17.18 18 16.95 18 16.72V4.36C18 3.61 17.394 3 16.649 3ZM14.3344 19.72V17.42C14.3344 17.35 14.3841 17.3 14.4536 17.3H16.7285L14.3344 19.72ZM17.2252 16.55H14.4536C13.9768 16.55 13.5894 16.94 13.5894 17.42V20.25H7.35099C7.01325 20.25 6.74503 19.97 6.74503 19.64V4.36C6.74503 4.02 7.01325 3.75 7.35099 3.75H16.649C16.9868 3.75 17.255 4.02 17.255 4.36L17.2252 16.55Z",
    fill: "#1D1E20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.692 13H9.3079C9.09929 13 8.93042 12.83 8.93042 12.62C8.93042 12.41 9.09929 12.24 9.3079 12.24H14.692C14.9006 12.24 15.0695 12.41 15.0695 12.62C15.0695 12.83 14.9006 13 14.692 13Z",
    fill: "#1D1E20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7351 15H9.3079C9.09929 15 8.93042 14.83 8.93042 14.62C8.93042 14.41 9.09929 14.24 9.3079 14.24H12.7351C12.9437 14.24 13.1125 14.41 13.1125 14.62C13.1125 14.83 12.9437 15 12.7351 15Z",
    fill: "#1D1E20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.692 11H9.3079C9.09929 11 8.93042 10.83 8.93042 10.62C8.93042 10.41 9.09929 10.24 9.3079 10.24H14.692C14.9006 10.24 15.0695 10.41 15.0695 10.62C15.0695 10.83 14.9006 11 14.692 11Z",
    fill: "#1D1E20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.692 9H9.3079C9.09929 9 8.93042 8.83 8.93042 8.62C8.93042 8.41 9.09929 8.24 9.3079 8.24H14.692C14.9006 8.24 15.0695 8.41 15.0695 8.62C15.0695 8.83 14.9006 9 14.692 9Z",
    fill: "#1D1E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.b9e464da.svg";
export { ForwardRef as ReactComponent };